import { render, staticRenderFns } from "./ProgressChipsListItem.vue?vue&type=template&id=35dda478&scoped=true"
import script from "./ProgressChipsListItem.vue?vue&type=script&lang=js"
export * from "./ProgressChipsListItem.vue?vue&type=script&lang=js"
import style0 from "./ProgressChipsListItem.vue?vue&type=style&index=0&id=35dda478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dda478",
  null
  
)

export default component.exports